import React from "react";
import ContentBox from "./ContentBox";
import { graphql, QueryRenderer } from "react-relay";
import environment from "../Environment";

const contentBoxQuery = graphql`
	query ContentBoxWrapperQuery($postId: String) {
		postSummary(postId: $postId) {
			...ContentBox_postSummary
		}
	}
`;
function ContentBoxWrapper(props) {

	const content = props.content;
	const postId = props.postId;

	return (
		<QueryRenderer
			environment={environment}
			query={contentBoxQuery}
			variables={{ postId: postId }}
			render={({ error, props }) => {
				if (error) {
					return <div>Error!</div>;
				}
				if (!props) {
					return <div>Loading...</div>;
				}
				return (
					<div>
						<ContentBox content={content} postSummary={props.postSummary} />
					</div>
				);
			}}
		/>
	);
}

export default ContentBoxWrapper;
